<template lang="pug">
.c-progress-form__element.c-progress-form__element--grouped.is-highlighted
  label.c-progress-form__title
    | {{$t('shared.insurances.vehicle_legal_insurance')}}
    Tooltip.p-bubble.p-bubble--inline.p-bubble--small(:content="$t('shared.insurances.vehicle_legal_insurance_tooltip')")
      Icon(icon="info" classes="p-bubble__icon")
  .c-multiple-choice
    .row.c-multiple-choice__options.text-center
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="rc" :name="name" :id="rcId" v-model="question")
        label.c-multiple-choice__label(:for="rcId")
          | {{$t('shared.insurances.vehicle_rc')}}
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="small_omnium" :name="name" :id="smallOmniumId" v-model="question")
        label.c-multiple-choice__label(:for="smallOmniumId")
          | {{$t('shared.insurances.vehicle_small_omnium')}}
      .column.large-4.c-multiple-choice__item
        input.c-multiple-choice__radio(type="radio" value="full_omnium" :name="name" :id="fullOmniumId" v-model="question")
        label.c-multiple-choice__label(:for="fullOmniumId")
          | {{$t('shared.insurances.vehicle_full_omnium')}}
</template>

<script>
import Icon from '../shared/Icon'
import Tooltip from '../shared/Tooltip'

export default {
  components: {
    Icon,
    Tooltip
  },
  props: [
    'risk'
  ],
  computed: {
    question: {
      get () {
        // set the property of risk if it does not exist
        if (typeof this.$store.state.belongings[this.risk] === 'undefined') {
          this.$store.state.belongings[this.risk] = {}
        }
        return this.$store.state.belongings[this.risk]['legal_insurance']
      },
      set (value) {
        this.$store.commit('updateRiskRiskObject', {risk: this.risk, risk_object: 'legal_insurance', value: value})
      }
    },
    name () {
      return `${this.risk}_name`
    },
    rcId () {
      return `${this.risk}_rc`
    },
    smallOmniumId () {
      return `${this.risk}_small_omnium`
    },
    fullOmniumId () {
      return `${this.risk}_full_omnium`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/insurances/VehicleLegal.vue